// @ is an alias to /src
import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {
  passwordPolicy: {
    password_minimum_length: {},
    require_latin_upper_case: {},
    require_latin_lower_case: {},
    require_number: {},
    require_non_alphanumeric: {},
    password_expiration: {},
    admin_reset_expiration_password: {},
    allow_user_reset_password: {},
    prevent_password_reuse: {},
  },
}

export const mutations = {
  SET_PASSWORD_POLICY(state, passwordPolicy) {
    state.passwordPolicy = passwordPolicy
  },
}

export const actions = {
  fetchPasswordPolicy({ commit }, payload) {
    return ApiService.fetchPasswordPolicy(payload)
      .then((res) => {
        const passwordPolicy = res.data
        commit('SET_PASSWORD_POLICY', passwordPolicy)
      })
      .catch((error) => {
        throw error
      })
  },
  editPasswordPolicy({ commit }, payload) {
    return ApiService.editPasswordPolicy(payload)
      .then((res) => {
        const passwordPolicy = res.data
        commit('SET_PASSWORD_POLICY', passwordPolicy)
      })
      .catch((error) => {
        throw error
      })
  },
}
